/*
 * *****************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Wed, Jul 21st 2021, 10:07:44 am
 *
 * *****************************************************
 */

import { List, Banner } from '@shopify/polaris';

import { ErrorObject } from 'utils/form/convert';

import { Container } from './styles';

type Props = {
  data: ErrorObject;
};

const PageErrorBanner = ({ data }: Props): JSX.Element => {
  // eslint-disable-next-line react/destructuring-assignment
  const { message, errors } = data.data ?? {
    message: 'Error(s) happened. Please try again later.'
  };
  let generalMessage = message;
  const isInputError = errors && errors.length !== 0;
  if (isInputError) generalMessage = 'Please fix the following error(s):';
  return (
    <Container>
      <Banner status="critical" title={generalMessage}>
        {isInputError && (
          <List type="bullet">
            {errors?.map(({ field, errors: fieldErrors }) => (
              <List.Item key={field}>{fieldErrors[0]}</List.Item>
            ))}
          </List>
        )}
      </Banner>
    </Container>
  );
};

export default PageErrorBanner;
